import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { TranslateService } from '@ngx-translate/core';
import { Select, Store } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { ConfirmationDialogComponent } from 'src/app/shared/components/confirmation-dialog/confirmation-dialog.component';
import { OperationMode, UserType } from 'src/app/shared/models/enum.model';
import { SetTitle } from 'src/app/shared/ngxs/action/account.action';
import { UserService } from 'src/app/shared/services/user.service';
import { RegisterComponent } from './../../shared/components/register/register.component';
import { UserModel } from './../../shared/models/user.model';
import {
  EditUser,
  FilterUsers,
  RemoveUser,
} from './../../shared/ngxs/action/management.action';
import { UserState } from './../../shared/ngxs/state/management.state';

@Component({
  selector: 'app-management',
  templateUrl: './management.component.html',
  styleUrls: ['./management.component.scss'],
})
export class ManagementComponent implements OnInit, OnDestroy {
  subscription = new Subscription();

  @ViewChild('paginator')
  paginator: MatPaginator;

  @Select(UserState.users)
  users$: Observable<UserModel[]>;

  @Select(UserState.usersTotal)
  usersTotal$: Observable<number>;

  columnsToDisplay: string[] = [
    'email',
    'firstname',
    'lastname',
    'roles',
    'actions',
  ];
  dataSource = new MatTableDataSource<UserModel>();

  pageSize = 5;
  pageSizeOptions = [5, 10, 25, 100];
  total = 0;
  userTypes = UserType;

  constructor(
    private dialog: MatDialog,
    private store: Store,
    private translateService: TranslateService,
    private userService: UserService
  ) {
    this.translateService.get('management').subscribe((x) => {
      this.store.dispatch(new SetTitle(x));
    });
  }

  getRoleString(data: string[]) {
    let result = '';

    data.forEach((x) => {
      result += `${x} `;
    });
    return result;
  }

  ngOnInit(): void {
    this.dataSource.paginator = this.paginator;
    this.store.dispatch(new FilterUsers());
    this.subscribeEvents();
  }

  subscribeEvents() {
    this.subscription.add(
      this.users$.subscribe((x) => {
        this.dataSource = new MatTableDataSource<UserModel>(x);
      })
    );

    this.subscription.add(
      this.usersTotal$.subscribe((x) => {
        if (x) {
          this.total = x;
        }
      })
    );
  }

  approveUser(event: any, model: UserModel) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        title: 'Approve User',
        text: 'Are you sure you want to approve selected user?',
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        const updated = Object.assign({}, model);
        updated.emailConfirmed = true;
        this.store.dispatch(new EditUser(updated));
      }
    });
  }

  declineUser(event: any) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        title: 'Decline User',
        text: 'Are you sure you want to decline selected user?',
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
      }
    });
  }

  addUser() {
    const dialogRef = this.dialog.open(RegisterComponent, {});
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
  editUser(event: any, model: UserModel) {
    const dialogRef = this.dialog.open(RegisterComponent, {
      data: {
        id: model.id,
        mode: OperationMode.Edit,
      },
    });
  }

  deleteUser(model: UserModel) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        title: 'Delete Period',
        text: 'Are you sure you want to delete this period?',
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.store.dispatch(new RemoveUser(model.id));
      }
    });
  }
}
